import type { ReactNode } from 'react';
import { EncabezadoPublico } from './EncabezadoPublico';
import { Pie } from './Pie';

// El pie va fuera del <main> a propósito: adentro quedaría limitado por el ancho
// máximo del contenido y se vería como una isla flotando.
export function PaginaPublica({ children, sinRelleno = false }: { children: ReactNode; sinRelleno?: boolean }) {
  return (
    <div className="pagina-publica">
      <EncabezadoPublico />
      <main id="contenido" className={sinRelleno ? 'pagina-publica__main pagina-publica__main--completo' : 'pagina-publica__main'}>
        {children}
      </main>
      <Pie />
    </div>
  );
}
